import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { GET_VL_CONNECT_DETAIL_REPORT } from "../../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import * as XLSX from "xlsx";
import fileSaver from "file-saver";

export const getDataListing = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  try {
    const { data } = await axios.post(
      "api/VLCShopKeeperTicket/GetVLConnectDetailReport",
      postedData,
    );

    dispatch({
      type: GET_VL_CONNECT_DETAIL_REPORT,
      payload: data?.response || [],
    });
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        logout();
        history.push("/login");
        return;
      }

      if (status === 400 && data?.errors) {
        const errorMessage = Object.values(data.errors).join(", \n");
        toast.error(errorMessage);
        return;
      }

      toast.error(
        data?.Message || data?.message || "Error while processing the request",
      );
    } else {
      toast.error("Error while processing the request");
    }
  } finally {
    dispatch(hideLoading());
  }
};

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());

  try {
    const { data } = await axios.post(
      `api/VLCShopKeeperTicket/GetVLConnectDetailReport`,
      { ...requestData, IsExport: true },
    );

    const outputFilename = `VL_Connect_Detail_Report_${Date.now()}`;
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const selectedColumns = [
      "distributor",
      "distCenter",
      "date",
      "vizId",
      "shopName",
      "cnic",
      "city",
      "locality",
      "subLocality",
      "shopCategory",
      "address",
      "queryType",
      "status",
    ];

    const exportData = (dataArray) => {
      const formattedData = dataArray.map((row) => ({
        distributor: row.distributor ?? "",
        distCenter: row.distCenter ?? "",
        date: row.date ? new Date(row.date).toLocaleDateString() : "",
        vizId: row.vizId ?? "",
        shopName: row.shopName ?? "",
        cnic: row.cnic ?? "",
        city: row.city ?? "",
        locality: row.locality ?? "",
        subLocality: row.subLocality ?? "",
        shopCategory: row.shopCategory ?? "",
        address: row.address ?? "",
        queryType: row.queryType ?? "",
        status: row.status ?? "",
      }));

      const ws = XLSX.utils.json_to_sheet(formattedData);
      const wb = {
        Sheets: { Report: ws },
        SheetNames: ["Report"],
      };

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const fileData = new Blob([excelBuffer], { type: fileType });

      fileSaver.saveAs(fileData, outputFilename + fileExtension);
    };

    exportData(data?.response?.data ?? []);
  } catch (error) {
    if (error.response) {
      if (error.response.status === 401) {
        logout();
        history.push("/login");
        return;
      }

      toast.error(
        error.response.data?.Message ||
          error.response.data?.message ||
          "Error while processing the request",
      );
    } else {
      toast.error("Error while processing the request");
    }
  } finally {
    dispatch(hideLoading());
  }
};
